

import React, { memo } from 'react';
import { AddonsConsumer } from '../../../index';
import VoiceOverModalComponent from '../components/VoiceOverModal';








function VoiceOverModal(props) {
  const { openHubSpotConversationsWidget } = props;
  return (
    <AddonsConsumer>
      {({ actions: { getBillingEntityCode } }) =>
      <VoiceOverModalComponent
        {...props}
        getBillingEntityCode={getBillingEntityCode}
        openHubSpotConversationsWidget={openHubSpotConversationsWidget} />}


    </AddonsConsumer>);

}

export default memo(VoiceOverModal);